import { ErrorHandler, Injectable } from '@angular/core';
import { CacheErrorModalComponent } from '../components/main/modals/cache-error-modal/cache-error-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { isLocalHost, Logger } from '@aiwyn/shared';

@Injectable({
  providedIn: 'root'
})
export class CacheErrorHandler implements ErrorHandler {

  surfaceLocalError = isLocalHost() ? this._surfaceError : undefined;

  constructor(
    private readonly dialog: MatDialog,
    private readonly logger: Logger,
  ) {}

  handleError(error: any): void {
    this.surfaceLocalError?.(error);

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      this.dialog.closeAll();
      this.dialog.open(CacheErrorModalComponent);
    }
  }

  private _surfaceError(error: any): void {
    this.logger.error('APP : CacheErrorHandler :', error);
  }
}
